'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { cn } from '@/shared/lib/cn';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Language, LocalizedString } from '@/shared/model/Language';
import { Button } from '@/shared/ui/button';
import { ToggleGroup } from '@/shared/ui/toggle-group';
import './blog-category-box.scss';

const MOCK_DATA: {
    id: string;
    name: LocalizedString;
    postCount: number;
}[] = [
    {
        id: '1',
        name: {
            [Language.EN]: 'Gastronomy',
            [Language.CS]: 'Gastronomie',
        },
        postCount: 12,
    },
    {
        id: '2',
        name: {
            [Language.EN]: 'Health',
            [Language.CS]: 'Zdraví',
        },
        postCount: 8,
    },
    {
        id: '3',
        name: {
            [Language.CS]: 'UGO fanda',
            [Language.EN]: 'UGO fan',
        },
        postCount: 2,
    },
    {
        id: '4',
        name: {
            [Language.CS]: 'Recepty',
            [Language.EN]: 'Recipes',
        },
        postCount: 5,
    },
    {
        id: '5',
        name: {
            [Language.CS]: 'Cukrfree',
            [Language.EN]: 'Sugarfree',
        },
        postCount: 5,
    },
];

const HORIZONTAL_BREAKPOINT = '(max-width: 77rem)';

export const BlogCategoryBox = () => {
    const t = useTranslations();
    const [emblaRef] = useEmblaCarousel({
        slidesToScroll: 1,
        inViewThreshold: 0.9,
        align: 'start',
        axis: 'y',
        breakpoints: {
            [HORIZONTAL_BREAKPOINT]: {
                axis: 'x',
            },
        },
    });
    const getLocalizedValue = useGetLocalizedValue();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    const handleClearFilter = () => {
        setSelectedIds([]);
    };

    return (
        <div className="blog-category-box">
            <div className="blog-category-box__top">
                <span>{t('BLOG.CATEGORY_BOX.TITLE')}</span>
                <Button
                    variant="ghost"
                    size="small"
                    onClick={handleClearFilter}
                    data-testid="blog-category-box-clear-filter-button"
                    className={cn(
                        'blog-category-box__clear-button',
                        !selectedIds.length && 'blog-category-box__clear-button--hidden',
                    )}
                >
                    {t('BLOG.CATEGORY_BOX.BUTTON')}
                </Button>
            </div>
            <div className="blog-category-box__content" ref={emblaRef}>
                <ToggleGroup
                    type="multiple"
                    value={selectedIds}
                    onValueChange={setSelectedIds}
                    className={cn('blog-category-box__toggle-group')}
                >
                    {MOCK_DATA.map(({ id, name, postCount }) => (
                        <ToggleGroup.Item
                            value={id}
                            key={id}
                            className="blog-category-box__toggle-item"
                            data-testid={`blog-category-box-toggle-item-${id}`}
                        >
                            <span data-testid={`blog-category-box-toggle-item-label-${id}`}>
                                {getLocalizedValue(name)}
                            </span>
                            <span data-testid={`blog-category-box-toggle-item-count-${id}`}>
                                ({postCount})
                            </span>
                        </ToggleGroup.Item>
                    ))}
                </ToggleGroup>
            </div>
        </div>
    );
};
